import moment from 'moment'

export default defaultPredictionResults => {
  const copy = defaultPredictionResults.slice()
  return copy.sort((a, b) => moment(b.createdAt).unix() - moment(a.createdAt).unix()).filter(result => Boolean(result.riskRating))
}
